module.exports = __webpack_public_path__ + "img/usz.1b9c1ca8.svg";